var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 215 215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ee8208;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ok"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    className: "cls-1",
    cx: 107.5,
    cy: 107.5,
    r: 107.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ok-2",
    "data-name": "Ok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ok-3",
    "data-name": "Ok",
    className: "cls-2",
    d: "M938.45,664.9a29.82,29.82,0,1,0-29.81-29.82,29.86,29.86,0,0,0,29.81,29.82m0-42.18a12.37,12.37,0,1,1-12.36,12.36,12.37,12.37,0,0,1,12.36-12.36",
    transform: "translate(-831 -554)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ok-4",
    "data-name": "Ok",
    className: "cls-2",
    d: "M950.54,689.17a55.77,55.77,0,0,0,17.35-7.2,8.77,8.77,0,1,0-9.32-14.86,37.93,37.93,0,0,1-40.14,0A8.77,8.77,0,1,0,909.1,682a55,55,0,0,0,17.35,7.2l-16.7,16.7a8.74,8.74,0,0,0,0,12.37,9.07,9.07,0,0,0,6.18,2.59,8.5,8.5,0,0,0,6.19-2.59l16.43-16.43L955,718.24a8.75,8.75,0,0,0,12.37-12.37Z",
    transform: "translate(-831 -554)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOk);
export default __webpack_public_path__ + "static/media/Ok.1f3d73288cf349f326afa2e2a401fb4c.svg";
export { ForwardRef as ReactComponent };